<template>
  <svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   inkscape:version="1.0rc1 (09960d6, 2020-04-09)"
   sodipodi:docname="tongue_L_square_4.svg"
   id="svg1118"
   version="1.1"
   viewBox="0 0 360 400"
   :height="height"
   :width="width">
  <defs
     id="defs1112">
      <filter id="blur">
         <feGaussianBlur in="SourceGraphic" stdDeviation="7,7" />
      </filter>
  </defs>
  <sodipodi:namedview
     inkscape:window-maximized="0"
     inkscape:window-y="23"
     inkscape:window-x="0"
     inkscape:window-height="755"
     inkscape:window-width="1252"
     scale-x="1"
     units="px"
     showgrid="false"
     inkscape:document-rotation="0"
     inkscape:current-layer="layer2"
     inkscape:document-units="px"
     inkscape:cy="143.32323"
     inkscape:cx="-33.911803"
     inkscape:zoom="0.98994949"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     borderopacity="1.0"
     bordercolor="#666666"
     pagecolor="#ffffff"
     id="base" />
  <metadata
     id="metadata1115">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title />
      </cc:Work>
    </rdf:RDF>
  </metadata>
    <path
       id="outside"
       style="opacity:0.299035;fill:#ff000000;stroke:#ffffff;stroke-width:0.536448;stroke-miterlimit:4;stroke-dasharray:none"
       d="M -27.217458,0.01783835 V 399.98216 H 387.21746 V 0.01783835 Z M 241.62336,23.525508 c 15.4817,-0.205148 30.76664,8.088195 49.60538,40.072597 21.76402,38.784735 19.5642,92.239525 18.24395,137.198705 -1.32025,44.95918 -10.06327,107.34604 -30.21697,139.80588 -20.15368,32.45985 -54.71801,33.31344 -99.82008,33.31344 -45.10212,0 -79.561439,-0.23599 -99.557018,-32.84473 C 59.883002,308.46264 54.017636,242.35173 50.241759,200.00391 46.465881,157.65609 49.695834,110.13257 68.984865,63.049325 108.09859,-3.9855682 138.51576,34.765289 182.77009,34.858481 c 23.51013,0.04951 41.30734,-11.100474 58.85327,-11.332973 z"
       inkscape:connector-curvature="0" />
    <path
       d="M 180 8.7871094 A 112.69226 31.88006 0 0 0 67.308594 40.667969 A 112.69226 31.88006 0 0 0 75.566406 52.644531 C 92.617999 27.875369 108.19294 22.543576 124.29297 23.816406 C 142.17072 21.966895 160.30202 34.790159 182.40625 34.84375 C 204.70385 34.897809 221.08754 21.610757 237.72852 23.753906 C 239.02972 23.626473 240.32678 23.542567 241.62305 23.525391 C 255.17427 23.345823 268.57491 29.679596 284.33984 52.710938 A 112.69226 31.88006 0 0 0 292.69141 40.667969 A 112.69226 31.88006 0 0 0 180 8.7871094 z "
       style="display:inline;fill:#280b0b;stroke:#000000;stroke-width:0.879489;stroke-opacity:1"
       id="mouth" />
  <g id="cover_layer">
   <path
       sodipodi:nodetypes="ssczssszcs"
       inkscape:connector-curvature="0"
       d="M 235.43427,23.402717 C 219.76316,23.610373 203.86763,33.568954 182.86961,33.524736 143.34396,33.441502 116.17693,-1.1687367 81.242601,58.703323 64.014648,100.75561 61.129824,143.20114 64.50224,181.024 c 3.372416,37.82285 8.611053,96.86966 26.470095,125.9941 17.859005,29.12442 48.636265,29.33519 88.919115,29.33519 40.28281,0 71.15386,-0.76238 89.15407,-29.75382 18.00023,-28.99143 25.80904,-84.71211 26.98822,-124.8673 C 297.21292,141.57699 299.17768,93.833965 279.7392,59.193464 262.91342,30.62667 249.26171,23.21949 235.43427,23.402717 Z"
       style="fill:none;stroke:#ff000000;stroke-width:2.04619px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
       id="cover" />
  </g>
  <g
     inkscape:groupmode="layer"
     id="body_layer"
     inkscape:label="Layer 2">
    <path
       sodipodi:nodetypes="ssczssszcs"
       inkscape:connector-curvature="0"
       d="M 241.62336,23.52551 C 224.07743,23.758009 206.28022,34.907991 182.77009,34.858483 138.51576,34.765291 108.09859,-3.9855671 68.984865,63.049327 49.695834,110.13257 46.465882,157.65609 50.24176,200.00391 c 3.775877,42.34782 9.641242,108.45873 29.636862,141.06749 19.995579,32.60874 54.454898,32.84473 99.557018,32.84473 45.10207,0 79.6664,-0.85359 99.82008,-33.31344 20.1537,-32.45984 28.89672,-94.8467 30.21697,-139.80588 1.32025,-44.95918 3.52007,-98.41396 -18.24395,-137.198703 C 272.39,31.613705 257.10506,23.320362 241.62336,23.52551 Z"
       style="fill:#f59a9a;stroke:#ff000000;stroke-width:2.29099px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
       id="body" />
    <path
       id="k-bl-li"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.536448;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="M 241.62336,23.525508 C 224.07743,23.758007 206.28022,34.907989 182.77009,34.858481 138.51576,34.765289 108.09859,-3.9855682 68.984865,63.049325 65.469944,71.629016 62.505118,80.261218 60.018034,88.89077 154.28414,103.42678 230.12707,98.413132 301.36701,88.513851 298.89408,79.778117 295.61658,71.417484 291.22874,63.598105 272.39,31.613703 257.10506,23.32036 241.62336,23.525508 Z"
       inkscape:connector-curvature="0" />
    <path
       id="lv-gb-r"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.822619;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="M 59.92135,89.222772 C 48.847183,127.83923 47.435093,166.39439 50.241759,200.00391 c 1.359746,14.3851 2.888671,31.13162 5.032038,48.27303 3.115172,22.23587 7.333846,44.29028 12.861153,65.29887 8.441889,-5.15555 26.216307,-11.37773 34.59471,-14.41277 C 90.988509,230.66133 87.371736,165.58785 101.03432,94.386374 Z"
       inkscape:connector-curvature="0" />
    <path
       sodipodi:nodetypes="ccccc"
       inkscape:connector-curvature="0"
       d="m 68.135086,313.57638 c 4.957688,13.94291 6.513049,21.25499 14.895337,32.33187 34.893277,-9.9098 159.890367,-12.49623 193.412217,-0.62084 7.83093,-13.41232 11.24816,-21.37215 16.0787,-36.33267 C 221.75147,276.2434 127.76766,281.6537 68.135086,313.57638 Z"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.822619;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="lg" />
    <path
       sodipodi:nodetypes="ccccc"
       inkscape:connector-curvature="0"
       d="M 102.73035,299.16315 C 90.9892,230.66152 87.372807,165.58642 101.03539,94.384958 c 57.84325,5.48043 108.78195,4.110113 156.61249,-0.341314 15.94193,75.127786 11.41667,137.558076 -1.1723,201.906436 -66.29082,-16.55244 -119.85756,-6.79354 -153.74523,3.21307 z"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.822619;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:0"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="st-sp" />
    <path
       id="lv-gb-l"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.536448;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="m 301.36701,88.513851 c -14.57115,1.959365 -28.79552,3.74396 -43.71913,5.529793 15.94899,75.140306 11.41933,137.550506 -1.17124,201.906776 0,0 21.80688,5.93051 36.0427,13.00275 0.0138,-0.0468 0.0267,-0.0938 0.0405,-0.14061 5.87484,-21.02411 10.72618,-50.25096 14.17649,-81.20955 0.006,-0.0484 0.0128,-0.0982 0.018,-0.14648 0.005,-0.0428 0.009,-0.0861 0.0135,-0.12889 0.0417,-0.37481 0.0801,-0.7535 0.12142,-1.12881 0.3733,-3.47956 0.71911,-6.83662 1.05902,-10.18464 0.54189,-5.47534 1.03963,-10.97379 1.49072,-16.47118 -1.22729,-36.54453 1.39819,-76.96165 -8.07195,-111.029159 z"
       inkscape:connector-curvature="0"
       sodipodi:nodetypes="cccccccscccc" />
    <path
       sodipodi:nodetypes="cscc"
       inkscape:connector-curvature="0"
       d="m 83.930085,345.28741 c 20.323515,27.98007 53.514165,28.21357 96.313775,28.21357 42.55291,0 75.70133,-0.77706 96.19878,-28.21357 -27.83398,-11.40577 -142.95715,-9.92862 -192.512555,0 z"
       style="fill:none;stroke:#00000f;stroke-width:0.821237;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="he" />
  </g>
</svg>
</template>

<script>
export default {
   props: {
      fragmented: {
         default: false
      },
      height: {
         default: 400
      },
      width: {
         default: 360
      }
   },
	mounted() {
		this.$emit('mounted');
	}
}
</script>